import React from "react";
import "./CustomInput.css";

const CustomInput = ({ label, name, type = "text", value, onChange, placeholder, maxLength, ...rest }) => {
  return (
    <div className="custom-input-wrapper"> 
      <input
        id={name}
        name={name}
        type={type}
        value={value}
        maxLength={maxLength}
        placeholder=" "
        onChange={onChange}
        className="custom-input-field"
        {...rest}
      />
      {label && <label htmlFor={name} className="custom-input-label">{label}</label>}
    </div>
  );
};

export default CustomInput;
